import "./CollectFileInfo.scss";

export default {
  props: {
    fileCount: Number,
    spaceName: String,
    spaceColor: String,
    totalSize: Number,
    sizeName: String,
  },
};
